// extracted by mini-css-extract-plugin
module.exports = {"mainError":"ErrorPage_mainError__jT0_i"};